import React, { useState } from "react";
import "./Pricing.css";
import { 
  FaCheck, FaStar, FaCrown, FaBolt, FaRocket, 
  FaShieldAlt, FaMapMarkedAlt, FaHeadset, FaBullseye 
} from "react-icons/fa";

const plans = [
  {
    name: "Starter",
    price: "999",
    tag: "Launch Pad",
    icon: <FaBolt />,
    features: [
      "15 Verified Leads / month",
      "Official Business Listing",
      "Phone & WhatsApp Visibility",
      "Basic Search Indexing",
      "Standard Dashboard",
      "Email Support"
    ],
  },
  {
    name: "Growth",
    price: "2,999",
    tag: "Market Favorite",
    popular: true,
    icon: <FaStar />,
    features: [
      "50 Quality Leads / month",
      "Verified Blue Badge",
      "Top 10 Search Priority",
      "10 Professional Photos",
      "Review Management Tools",
      "Priority WhatsApp Support"
    ],
  },
  {
    name: "Premium",
    price: "6,999",
    tag: "Scale Up",
    icon: <FaCrown />,
    features: [
      "150 Exclusive Leads / mo",
      "Top-3 Search Ranking",
      "Dedicated Account Manager",
      "Unlimited Photos & Videos",
      "Google My Business Sync",
      "Direct Call Priority"
    ],
  },
  {
    name: "Elite",
    price: "18,000",
    tag: "Dominance",
    elite: true,
    icon: <FaRocket />,
    features: [
      "300+ Priority Hot Leads",
      "Guaranteed #1 Ranking",
      "Homepage Spotlight Feature",
      "Exclusive Banner Ads",
      "24/7 VIP Concierge Support",
      "Custom Brand Video"
    ],
  },
];

export default function Pricing() {
  const [openFaq, setOpenFaq] = useState(null);

  const handleWhatsApp = (plan) => {
  const message = `
Hello BizzMark Team 👋

I am interested in the *${plan.name} Plan*.

💰 Price: ₹${plan.price}/month

Please share complete details and activation process.

Thank you!
  `;

  const encodedMessage = encodeURIComponent(message);

  window.open(
    `https://wa.me/919967956503?text=${encodedMessage}`,
    "_blank"
  );
};

  return (
    <div className="bm-elite-page">
      {/* 1. COMPACT HERO + PRICING (FIRST SCREEN) */}
      <section className="bm-top-section">
        <div className="bm-container">
          <div className="bm-hero-mini">
            <span className="bm-badge">TRUSTED BY 50,000+ VENDORS</span>
            <h1>Invest in Your <span>Business Success</span></h1>
            <p>Choose a plan that fits your business goals. No hidden fees.</p>
          </div>

          <div className="bm-pricing-grid">
            {plans.map((plan, i) => (
              <div key={i} className={`bm-elite-card ${plan.popular ? "is-popular" : ""} ${plan.elite ? "is-elite" : ""}`}>
                {plan.popular && <div className="bm-tag-pop">BEST VALUE</div>}
                {plan.elite && <div className="bm-tag-elite">PRO CHOICE</div>}
                
                <div className="card-top">
                  <div className="card-icon-box">{plan.icon}</div>
                  <h3>{plan.name}</h3>
                  <div className="card-price">
                    <span className="currency">₹</span>{plan.price}<span className="duration">/month</span>
                  </div>
                </div>

                <ul className="card-list">
                  {plan.features.map((feat, idx) => (
                    <li key={idx}><FaCheck className="check-icon" /> {feat}</li>
                  ))}
                </ul>

                <button className="card-action-btn" onClick={() => handleWhatsApp(plan)}>Get Started</button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 2. VALUE PROPOSITION SECTION */}
      <section className="bm-value-props">
        <div className="bm-container">
          <div className="section-header">
            <h2>The BizzMark Edge</h2>
            
          </div>
          <p className="section-header">Why businesses choose our verified lead model</p>
          <div className="props-grid">
            <div className="prop-item">
              <FaShieldAlt />
              <h4>Verified Quality</h4>
              <p>Every lead passes through proprietary OTP verification.</p>
            </div>
            <div className="prop-item">
              <FaBullseye />
              <h4>Laser Targeting</h4>
              <p>Connect with customers based on exact local intent.</p>
            </div>
            <div className="prop-item">
              <FaMapMarkedAlt />
              <h4>Local Dominance</h4>
              <p>Rank higher in map searches where customers look first.</p>
            </div>
            <div className="prop-item">
              <FaHeadset />
              <h4>Expert Support</h4>
              <p>Dedicated managers to help you optimize for conversions.</p>
            </div>
          </div>
        </div>
      </section>

      {/* 3. FAQ SECTION */}
      <section className="bm-faq">
        <div className="bm-container">
          <div className="section-header"><h2>Frequently Asked Questions</h2></div>
          <div className="faq-wrapper">
            {[
              ["How do I receive leads?", "Leads are delivered via WhatsApp and your dashboard instantly."],
              ["Can I upgrade plans?", "Yes, you can upgrade or downgrade at any time from your portal."],
              ["Are the leads genuine?", "Yes, we use a 2-step verification for every enquiry."]
            ].map((faq, i) => (
              <div key={i} className={`faq-box ${openFaq === i ? "active" : ""}`} onClick={() => setOpenFaq(openFaq === i ? null : i)}>
                <div className="faq-q">{faq[0]} <span>{openFaq === i ? "−" : "+"}</span></div>
                <div className="faq-a">{faq[1]}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* <a href="#" className="whatsapp-float"><FaWhatsapp /> Chat with Experts</a> */}
    </div>
  );
}